import { uuidv7 } from 'uuidv7';
import { z } from 'zod';

const UUID_V7_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iu;

export const uuidV7Schema = z
  .string()
  .regex(UUID_V7_PATTERN, 'UUIDv7 required');

export const generateUuidV7 = (): string => uuidv7();

export const botScopeSchema = z
  .object({
    companyId: uuidV7Schema,
    botId: uuidV7Schema,
  })
  .strict();

export type BotScope = z.infer<typeof botScopeSchema>;
